import { cellphoneValidation, fullName } from '@convenia/helpers'

export default () => ({
  name: {
    type: 'text',
    label: 'Nome',
    placeholder: 'Nome',
    validation: { custom: (_, value) => fullName(value) },
    validationMsg: 'Nome e sobrenome obrigatórios',
  },

  emergencyContactRelationId: {
    type: 'select',
    label: 'Relação',
    placeholder: 'Relação',
    displayBy: 'name',
    trackBy: 'id',
    options: [],
    optionsSrc: 'emergencyRelations',
  },

  telephone: {
    type: 'text',
    label: 'Telefone',
    placeholder: 'Telefone',
    inputmode: 'numeric',
    mask: [ '(##) ####-####', '(##) #####-####' ],
    validation: 'min:14',
    validationMsg: 'Número inválido',
    emitPreValidation: true,
  },

  workPhone: {
    type: 'text',
    label: 'Telefone de trabalho',
    placeholder: 'Telefone de trabalho',
    inputmode: 'numeric',
    mask: [ '(##) ####-####', '(##) #####-####' ],
    validation: 'min:14',
    validationMsg: 'Número inválido',
    emitPreValidation: true,
  },

  cellphone: {
    type: 'text',
    label: 'Celular',
    placeholder: 'Celular',
    inputmode: 'numeric',
    mask: '(##) #####-####',
    validation: { custom: (_, value) => cellphoneValidation(value) },
    validationMsg: 'Número inválido',
    emitPreValidation: true,
  },

  email: {
    type: 'text',
    label: 'E-mail',
    placeholder: 'E-mail',
    validation: { max: 106, email: true },
    emitPreValidation: true,
  },
})
